export default class ToggleItems {
    config = {};

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.init();
    }

    init() {
        this.parent = this.elem.parentElement;
        this.items = Array.from(this.parent.querySelectorAll('.is-toggle-item'));
        this.span = Array.from(this.elem.querySelectorAll('span'));

        this.elem.addEventListener('click', () => {
            this.items.forEach((item) => {
                item.classList.toggle('d-none');
            });

            this.span.forEach((item) => {
                item.classList.toggle('d-none');
            });
        });
    }
}
